import React from 'react';

const KeyInformationSection: React.FC = () => (
  <section id="about" className="py-12 bg-gray-50">
    <div className="max-w-7xl mx-auto px-6">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        {/* Left Content */}
        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm">
          <div className="inline-block px-4 py-1 border border-gray-300 rounded-full text-sm mb-6">
            About the Awards
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Recognizing Digital Excellence
          </h2>
          <div className="space-y-4 text-gray-600 leading-relaxed">
            <p>
              The Sinar Mas Digital Awards recognize and celebrate the most
              innovative digital initiatives, transformative projects, and
              exceptional talent within the Sinar Mas Group.
            </p>
            <p>
              Since 2023, we&apos;ve been honoring teams and individuals who
              push the boundaries of digital innovation, driving sustainable
              growth and positive change across our organization.
            </p>
            <p>
              Each year, the awards spotlight groundbreaking solutions in AI,
              digital transformation, sustainability, and leadership excellence.
            </p>
          </div>
        </div>

        {/* Right Stats Grid */}
        <div className="grid grid-cols-2 gap-4">
          <div className="bg-white rounded-2xl p-8 shadow-sm">
            <div className="text-4xl md:text-5xl font-bold text-smdd-red mb-2">
              180+
            </div>
            <div className="text-gray-500 text-sm">Participants</div>
          </div>
          <div className="bg-white rounded-2xl p-8 shadow-sm">
            <div className="text-4xl md:text-5xl font-bold text-smdd-red mb-2">
              6
            </div>
            <div className="text-gray-500 text-sm">Categories</div>
          </div>
          <div className="bg-white rounded-2xl p-8 shadow-sm">
            <div className="text-4xl md:text-5xl font-bold text-smdd-red mb-2">
              75
            </div>
            <div className="text-gray-500 text-sm">Projects</div>
          </div>
          <div className="bg-white rounded-2xl p-8 shadow-sm">
            <div className="text-4xl md:text-5xl font-bold text-smdd-red mb-2">
              21
            </div>
            <div className="text-gray-500 text-sm">Winners</div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default KeyInformationSection;
